module.exports = __webpack_public_path__ + "img/gongsijies.d75919da.png";